<template>
  <div class="characteristics" :id="characteristics?.isShortCharacteristics ? '' : 'characteristics'">
    <h2 :class="[isShort ? 'short-title' : 'title']">Характеристики</h2>
    <div class="list">
      <div class="item" v-for="(characteristic, index) in characteristicsList" :key="index">
        <span
          class="subtitle"
          v-if="characteristic.subtitle"
          :class="{ short: characteristics?.isShortCharacteristics }"
        >
          {{ characteristic.subtitle }}
        </span>
        <ul class="sublist">
          <li
            class="characteristic"
            :class="{ ['characteristic_one-row']: isShort }"
            v-for="(value, index) in characteristic.values"
            :key="index"
          >
            <span class="name">{{ value.name }}</span>
            <span :title="value.value" class="value">{{ value.value }}</span>
          </li>
        </ul>
      </div>
    </div>
    <a
      @click="scrollToExpandedCharacteristics"
      href="#characteristics"
      class="show-more"
      v-if="isExpandable && isShort"
    >
      Все характеристики
    </a>
    <span class="show-more" @click="showMoreCharacteristics" v-else-if="isHidden && isExpandable">
      Все характеристики
    </span>
    <span class="show-more" @click="showLessCharacteristics" v-else-if="!isHidden && isExpandable">
      Основные характеристики
    </span>
  </div>
</template>

<script setup lang="ts">
// TODO: Replace with IconUi from @/shared/legacy-kit/components/icon/index.vue when available
// TODO: Replace with globalScrollTo from @/shared/helpers/business/useGlobalScroll when available

import { ref, computed } from 'vue';
import type { ICharacteristics } from '../../models/characteristic';

interface Props {
  characteristics: ICharacteristics;
  showNumber?: number;
  isShort?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  showNumber: 12,
  isShort: false,
});

const isHidden = ref(true);

const isExpandable = computed(() => {
  return props.showNumber < Math.max(...props.characteristics?.list.map((item) => item.values.length));
});

const characteristicsList = computed(() => {
  return props.characteristics?.list.map((listItem) => ({
    ...listItem,
    values: listItem.values.slice(0, isHidden.value ? props.showNumber : listItem.values.length),
  }));
});

const showMoreCharacteristics = () => {
  isHidden.value = false;
};

const showLessCharacteristics = () => {
  isHidden.value = true;
};

const scrollToExpandedCharacteristics = (event: Event): void => {
  const expandedCharacteristics = document.getElementById('characteristics');

  if (expandedCharacteristics) {
    event.preventDefault();

    // TODO: Replace with globalScrollTo from @/shared/helpers/business/useGlobalScroll when available
    expandedCharacteristics.scrollIntoView({ behavior: 'smooth' });
  }
};
</script>

<style lang="stylus" scoped>
.characteristics
  font-family 'Inter'

  .title
    font-weight 600
    font-size 28px
    line-height 36px
    letter-spacing -0.021em
    margin 0
    margin-bottom 32px

  .list
    display flex
    flex-wrap wrap

    .item
      margin-top 32px
      width 100%

      &:first-child
        margin-top 0

      .subtitle
        font-size 18px
        font-weight 600
        line-height 24px
        letter-spacing -0.007em
        margin 0

        &.short
          font-size 14px
          line-height 20px
          letter-spacing -0.01em

      .sublist
        display flex
        flex-direction row
        flex-wrap wrap
        margin 0

        .characteristic
          display grid
          grid-template-columns 1fr 3fr
          flex: 0 1 100%;
          margin-top 12px

          +Media(Desktop, DesktopMax)
            flex: 0 1 50%;

          &_one-row
            flex: 0 1 100%;

          .name, .value
            font-size 14px
            font-weight 400
            line-height 20px
            letter-spacing -0.005em


          .name
            color hsla(229, 6%, 57%, 1)

          .value
            word-break break-word
            max-width 200px
            max-height 200px
            text-overflow ellipsis
            overflow hidden
            padding-left 96px

            display: -webkit-box !important;
            -webkit-line-clamp: 6;
            -webkit-box-orient: vertical;
            white-space: normal;

.show-more
    display inline-block
    margin-top 28px
    color hsla(229, 6%, 57%, 1)
    text-decoration underline
    cursor pointer

.short-title
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: -0.01em;
  color: #141415;
  margin-bottom 16px;
</style>
